import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useFeeMaster = () =>
  useQuery({ queryKey: ["fee-master"], queryFn: () => api.get("/fee-master").then((r) => r.data) });

export const useSettings = () =>
  useQuery({ queryKey: ["settings"], queryFn: () => api.get("/settings").then((r) => r.data) });
